import { PieChart } from '@mui/x-charts'
import React from 'react'

export default function PayChart(apifeatch) {
    console.log(apifeatch)
    const totals = apifeatch.apifeatch.reduce(
        (acc, entry) => {
          acc.totalReached += entry.numOfPeopleReached;
          acc.totalSaved += entry.numOfPeopleSaved;
          acc.totalRepent += entry.numOfPeopleRepent;
          return acc;
        },
        { totalReached: 0, totalSaved: 0, totalRepent: 0 }
      );
  return (
    <div>
<div className=''>
    <p className='text-lg mb-4 font-bold mx-5 mt-5'>Over View</p>
    <div className='flex flex-row justify-between w-full px-5'>
        <p> Analitics</p>
     
<select id="month" name="month" className='border border-1 rounded-sm'>
  <option value="January">January</option>
  <option value="February">February</option>
  <option value="March">March</option>
  <option value="April">April</option>
  <option value="May">May</option>
  <option value="June">June</option>
  <option value="July">July</option>
  <option value="August">August</option>
  <option value="September">September</option>
  <option value="October">October</option>
  <option value="November">November</option>
  <option value="December">December</option>
</select>

    </div>

    <div className='flex gap-4 flex-wrap p-2 mt-5'>
      
    <div className=' bg-sky-400 text-white w-[150px] h-[100px] rounded-[8px] p-5' >
        <p>Total Outreach</p>
        <div className='flex gap-4 mt-3'>

        <p className='text-lg font-bold'>{totals.totalReached}</p>
        <p>+</p>

        </div>
        </div>  
        <div className=' bg-orange-400 text-white w-[150px] h-[100px] rounded-[8px] p-5' >
        <p>Total Saved</p>
        <div className='flex mt-3 gap-4'>

        <p className='text-lg font-bold'>{totals.totalSaved}</p>
        <p>+</p>

        </div>
        </div>  
        <div className=' bg-green-400 text-white w-[150px] h-[100px] rounded-[8px] p-5' >
        <p>Total Repent</p>
        <div className='flex gap-4 mt-3'>

        <p className='text-2lg font-bold'>{totals.totalRepent}</p>
        <p>+</p>

        </div>
        </div>  
        

    </div>
</div>
<div>
  <p className='text-md font-bold my-5 ml-5'>Pie charts express portions of a whole</p>
</div>
      <PieChart
  series={[
    {
      data: [
        { id: 0, value: totals.totalReached, label: 'Reached' },
        { id: 1, value: totals.totalSaved, label: 'Repent' },
        { id: 2, value: totals.totalRepent, label: 'Saved' },
      ],
    },
  ]}
  width={400}
  height={200}
/>
    </div>
   
  )
}
